import script from "./sf-button-text.vue?vue&type=script&setup=true&lang=ts"
export * from "./sf-button-text.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__